import { getAppData } from '../../lib/api/common';
import { getNewsPage, getNews } from '../../lib/api/news';

import Layout from '../../components/layout/Layout';
import SeoMaticHead from '../../components/common/SeoMaticHead'
import LatestNews from '../../components/content/pageBuilderBlocks/LatestNews';
import PageHeader from '../../components/content/page/PageHeader';
import { revalidateSeconds } from "../../lib/helpers/revalidateSeconds";

export type NewsProps = {
	page: any
	updatesPage: any
	news: Array<any>
	app: any
}


export async function getStaticProps(context: any) {

	const app: any = await getAppData();
	const data: any = await getNewsPage(
		context.preview ? context.previewData?.token : undefined
	);
	const news: any = await getNews();

	return {
		props: {
			app: app ? app : null,
			page: data ? data.page : null,
			updatesPage: data ? data.updatesPage : null,
			news: news ? news.entries : null,
		},
		revalidate: revalidateSeconds()
	};
}



export default function News(props: NewsProps) {

	const { page, updatesPage, news, app } = props

	// console.log('News page props: ', props)

	const breadcrumbs = [
		{
			id: updatesPage.id,
			title: updatesPage.title,
			uri: updatesPage.uri,
		},
		{
			id: page.id,
			title: page.title,
			uri: null,
		}
	]

	return (
		<>
			<SeoMaticHead seo={page.seo} />
			<Layout
				appData={app}
				subHeader={breadcrumbs}
			>
				<>
					<PageHeader page={page} />
					<LatestNews news={news} />
				</>
			</Layout>
		</>
	)
}
